export default "__VITE_ASSET__1a15b34f__"